var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m463.702 162.655-21.211-148.491c-1.744-12.174-16.707-17.233-25.459-8.481l-30.894 30.894c-39.727-23.965-84.829-36.577-131.206-36.577-139.468 0-251.441 109.16-254.927 248.511-.19 7.617 5.347 14.15 12.876 15.234l59.941 8.569c8.936 1.304 17.249-5.712 17.125-15.058-1.243-91.97 73.039-167.256 164.985-167.256 22.265 0 44.267 4.526 64.6 13.183l-29.78 29.78c-8.697 8.697-3.761 23.706 8.481 25.459l148.491 21.211c9.784 1.475 18.381-7.034 16.978-16.978z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m499.117 249.412-59.897-8.555c-7.738-.98-17.124 5.651-17.124 16.143 0 90.981-74.019 165-165 165-22.148 0-44.048-4.482-64.306-13.052l28.828-28.828c8.697-8.697 3.761-23.706-8.481-25.459l-148.491-21.226c-9.753-1.393-18.39 6.971-16.978 16.978l21.21 148.492c1.746 12.187 16.696 17.212 25.459 8.481l31.641-31.626c39.536 23.745 84.609 36.24 131.118 36.24 138.794 0 250.752-108.618 254.897-247.28.22-7.632-5.317-14.224-12.876-15.308z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.ec384b3ca1e83a38ce9965cfc791220c.svg";
export { ForwardRef as ReactComponent };